const SchedulePage = {
  VIEW: 'View',
  NEW: 'New',
  ADVANCED: 'Advanced',
  SUBMITTED: 'Submitted',
  PRESENTATION: 'Presentation',
  STANDBY: 'Standby',
};

export default SchedulePage;
